const c = ["#cfdde9", "#8db5d4", "#5d93c4", "#1b4b96"], d = ["#cfdde9", "#a7c4da", "#72a6ce", "#4780b9", "#1b4b96"], b = [
  "#f0f3fe",
  "#cfdde9",
  "#a7c4da",
  "#72a6ce",
  "#4780b9",
  "#1b4b96"
];
export {
  c as DEMOGRAPHICS_BLUE_4,
  d as DEMOGRAPHICS_BLUE_5,
  b as DEMOGRAPHICS_BLUE_6
};
//# sourceMappingURL=index.es5687.js.map
